import HelpOutline from "@mui/icons-material/HelpOutline";
import { Tooltip, TooltipProps, Typography, SxProps } from "@mui/material";

import { Row } from "@rui/Stack";

const HelpTip = ({
  color = "shades.neutral.200",
  content,
  size = "12px",
  children,
  sx,
  enterDelay,
}: {
  color?: string;
  content: string;
  size?: string;
  children?: React.ReactNode;
  sx?: SxProps;
  enterDelay?: TooltipProps["enterDelay"];
}) => {
  if (children) {
    return (
      <Tooltip
        enterDelay={enterDelay}
        title={content}
        sx={{ cursor: "default", ...sx }}
      >
        <Row variant="left" spacing="4px">
          <HelpOutline
            sx={{
              fontSize: size,
              color,
              ...sx,
            }}
          />
          <Typography variant="labelMed" color={color} lineHeight={1}>
            {children}
          </Typography>
        </Row>
      </Tooltip>
    );
  }

  return (
    <Tooltip enterDelay={enterDelay} title={content} sx={{ ...sx }}>
      <HelpOutline
        sx={{
          fontSize: size,
          ml: 1,
          color,
          ...sx,
        }}
      />
    </Tooltip>
  );
};

export default HelpTip;
